import { render } from "./BranchSignatoriesTable.vue?vue&type=template&id=6433f1e0"
import script from "./BranchSignatoriesTable.vue?vue&type=script&lang=js"
export * from "./BranchSignatoriesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__